import './App.css';
import { useState } from 'react'
import { useDispatch } from 'react-redux';
import { agregarNombre, cargarProyecto, limpiarProyecto, setAutoSave } from './features/metadata/MetadataLogic.jsx'
import { Link } from 'react-router-dom'

export default function App() {
  //Redux
  const dispatch = useDispatch()
  
  const [index, setIndex] = useState(0)
  const [projName, setName] = useState("")
  const [projDate, setDate] = useState("")

  //For read OS files
  const reader = new FileReader()

  //LOCALSTORAGE
  const localStorage = window.localStorage
  const [autoSave, setAutoSave] = useState(JSON.parse(localStorage.getItem("autoSave")))
  const [time, setTime] = useState(JSON.parse(localStorage.getItem("time")))
  const [theme, setTheme] = useState(localStorage.getItem("theme"))
  
  //In case don't exist the dates in LocalStorage
  if (autoSave === null){
    localStorage.setItem("autoSave", true)
    localStorage.setItem("time", 20)
    localStorage.setItem("theme", "xForce Design")
  }
  
  //HANDLES
  const handleNameChange = (name) => {
    setName(name)
    dispatch(agregarNombre(name))
  }
  //Function to redirect to Building Area when press Enter at the Project Name Input Field
  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      const link = document.getElementById("createProject")
      link.click()
    }
  }
  const handleConf = () => {
    localStorage.setItem("autoSave", autoSave)
    localStorage.setItem("time", time)
    localStorage.setItem("theme", theme)
  }

  /* Use to change the content of the right half
     @param {int} index - Index of the content want to see
     @returns The content of the selected page index at right container
  */
  function showIndexedPage(index) {
    switch (index) {
      case 0: return(
        <div className="half right" style={{padding: '6vh'}}>
          <h1>Nuevo Proyecto</h1>
          <div>
            <label htmlFor="nombreProyecto" className="form-label" ><strong>Nombre del Proyecto</strong></label>
            <input type="text"
              autoComplete="off"
              className="form-control form-label"
              name="nombreProyecto"
              id="nombreProyecto"
              aria-describedby="helpId"
              placeholder="Nombre del proyecto"
              value={projName}
              onChange={(e) => handleNameChange(e.target.value)}
              onKeyUp={handleEnter}
            />
          </div><br/>
          <Link id='createProject' type="button" className="btn btn-primary" to="/BuildingArea">Crear Proyecto</Link>
        </div>
      )
      case 1: return(
        <div className="half right" style={{padding: '6vh'}}>
          <h1>Cargar Proyecto</h1>
          <div>
            <label htmlFor="nombreProyecto" className="form-label"><strong>Nombre del Proyecto:</strong> {projName}</label><br />
            <label htmlFor="projectDate" className="form-label"><strong>Fecha:</strong> {projDate}</label><br />
          </div>
          <input type='file' accept='.json' multiple={false} id="file-input" style={{ display: 'none' }} onChange={handleFileSelect} />

          <div style={{display:'flex', justifyContent:'space-around'}}>
              <button type="button" className="btn btn-primary"
                onClick={() => {
                  document.getElementById("file-input").click()
                }}
              > Cargar Proyecto </button>
              <Link type="button" className="btn btn-success" to="/BuildingArea">✏️ Editar Proyecto</Link>
          </div>
        </div>
      )
      case 2: return(
        <div className="half right" style={{padding: '6vh'}}>
          <h1>Configuracion</h1>
            <div className="form-switch form-check-reverse">
              <h3 className="form-check-label" htmlFor="flexSwitchCheckReverse">Guardado Automático
                <input className="form-check-input" style={{marginLeft:'3vh'}} type="checkbox" role='switch' id="flexSwitchCheckReverse" onChange={()=>{setAutoSave(!autoSave)}} defaultChecked={autoSave} />
              </h3>
            </div>
            <h3 >Tiempo (minutos): 
              <input type="number" value={time} style={{width:'5vw'}} className="conf-item"
              disabled={!autoSave}
              onChange={(e)=>{setTime(e.target.value)}} />
            </h3>
            <h3>Tema: 
              <div className="dropdown open dropdown-btn conf-item">
                <button className="btn btn-primary dropdown-toggle" type="button" id="triggerId" data-bs-toggle="dropdown" 
                aria-haspopup="true" aria-expanded="true">
                      {theme}
                </button>
                <div className="dropdown-menu" aria-labelledby="triggerId">
                  <button className="dropdown-item" onClick={(e)=>{setTheme(e.target.innerText)}}>xForce Design</button>
                  <button className="dropdown-item" onClick={(e)=>{setTheme(e.target.innerText)}}>Claro</button>
                  <button className="dropdown-item" onClick={(e)=>{setTheme(e.target.innerText)}}>Oscuro</button>
                </div>
              </div>
            </h3>

            <br /><br />
            <button className="btn btn-success" onClick={handleConf}>Guardar Configuración</button>
        </div>
      )
      default: break
    }
  }

  //Functions to Load Projects
  function handleFileSelect(event) {
    const file = event.target.files[0];
    if(!file){
      alert("No se ha cargado ningún proyecto")
      return
    }
    reader.onload = handleFileLoad;
    const date = file.lastModifiedDate
    setDate(`${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`)
    reader.readAsText(file)
  }
  function handleFileLoad(event){
    let project = event.target.result
    project = JSON.parse(project)
    setName(project.projectName)
    dispatch(cargarProyecto({ project }))
  }

  return (
    <div className="App">
      <h1>PsychoProject V1.0</h1>
      <div className="containerData">
        <div className="half left" style={{padding: '6vh'}}>
            <ul className="nav flex-column mt-4">
              <div className="d-grid mb-2 btnMenu">
                <button type="button" name="newProyect" id="newProyect" className="btn btn-light btnMenu"
                  onClick={() => {
                    setName("")
                    dispatch(limpiarProyecto())
                    setIndex(0)
                  }}
                  >Nuevo Proyecto</button>
              </div>

              <div className="d-grid mb-2 btnMenu">
                <button type="button" name="loadProyect" id="loadProyect" className="btn btn-light btnMenu"
                  onClick={() => {
                    setName("")
                    setDate("")
                    dispatch(limpiarProyecto())
                    setIndex(1)
                  }}
                >Cargar Proyecto</button>
              </div>

              <div className="d-grid mb-2 btnMenu">
                <button type="button" name="config" id="config" className="btn btn-light btnMenu"
                  onClick={() => {
                    setIndex(2)
                  }}
                >Configuración</button>
              </div>
            </ul>
        </div>

        {showIndexedPage(index)}
      </div>
    </div>
  )
}